import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog, MatTab } from '@angular/material';
import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';

import { RepAcctComponent } from '../rep-acct/rep-acct.component';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-trail-balance',
  templateUrl: './trail-balance.component.html',
  styleUrls: ['./trail-balance.component.css']
})
export class TrailBalanceComponent implements OnInit {

  public menu_item_id = '48';
  
  model = { 'fromDate': new Date(), 'toDate': new Date(), 'level_id': '', 'title': 'ميزان المراجعة' };
  levelList = [];
  // [{ 'level_id': 4, 'level_name': 'المستوى الرابع (الحسابات الفرعية)' },
  // { 'level_id': 3, 'level_name': 'المستوى الثالث (الحسابات الرئيسية)' }];

  private dp = [];
  displayedColumns = ['acct_number', 'acct_name', 'open_dr', 'open_cr', 'current_dr', 'current_cr', 'close_dr',
    'close_cr'];
  displayedColumns2 = ['acct_number', 'acct_name', 'open_dr', 'open_cr', 'current_dr', 'current_cr', 'close_dr',
    'close_cr'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  from_date;
  to_date;
  mainAcctList = [];

  repAcctDialogRef: MatDialogRef<RepAcctComponent>;

  Trail_Balance; From_Date; To_Date; Level;
  From_Date_Msg; To_Date_Msg;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Trail_Balance').subscribe((res: string) => {
      this.Trail_Balance = res;
    });
    this.model['title'] = this.Trail_Balance;

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });
    
    translate.get('Level').subscribe((res: string) => {
      this.Level = res;
    });
    
    translate.get('From_Date_Msg').subscribe((res: string) => {
      this.From_Date_Msg = res;
    });

    translate.get('To_Date_Msg').subscribe((res: string) => {
      this.To_Date_Msg = res;
    });
  }

  ngOnInit() {
    this.from_date = (this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
      this.model['fromDate'].getDate() + ' 00:00:00');
    this.to_date = (this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
      this.model['toDate'].getDate() + ' 23:59:59');

    // get levels
    let query = "SELECT MIN(`acct_level`) AS `from_level`, MAX(`acct_level`) AS `to_level` FROM `sub_acct`";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        let from_level = Number(data.data['list'][0]['from_level']);
        let to_level = Number(data.data['list'][0]['to_level']); 
        this.model['level_id'] = data.data['list'][0]['from_level'];

        for (; from_level <= to_level; from_level++) {
          this.levelList.push({ 'level_id': from_level, 'level_name': 'المستوى ' + from_level, 
            'level_name_en': 'Level ' + from_level });
        }
      });
  }

  search() {
    this.dp = [];

    if (this.model['fromDate'] == undefined || this.model['fromDate'].toString() == '') {
      alert(this.From_Date_Msg);
      return;
    }

    if (this.model['toDate'] == undefined || this.model['toDate'].toString() == '') {
      alert(this.To_Date_Msg);
      return;
    }

    this.from_date = (this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
      this.model['fromDate'].getDate() + ' 00:00:00');
    this.to_date = (this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
      this.model['toDate'].getDate() + ' 23:59:59');

    let obj = { cmd: 'getTrailBalance', from_date: this.from_date, to_date: this.to_date, 
      acct_level: this.model['level_id'] };

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        // console.log(data);
        this.applicationConstants.appComp.hideBusyCursor();

        if (data.status['type'] == 'success') 
          this.dp = data.status['msg'][0]['list'];
        else
          alert(this.applicationConstants.user_lang == 'ar' ? data.status['msg'][0]['msg_ar'] : data.status['msg'][0]['msg_en']);

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  showAcctRep(row) {
    // this.model['level_id'] == '4' && row.acct_number != '0'
    if (row.is_leaf == '1') {
      row.from_date = this.from_date;
      row.to_date = this.to_date;
      // console.log(row.acct_number);
      this.repAcctDialogRef = this.dialog.open(RepAcctComponent, {
        hasBackdrop: false,
        data: row,
        width: "90%",
        height: "95%",
      });
      this.repAcctDialogRef
        .afterClosed()
        .subscribe(result => {
        });
    }
  }

  print() {
    let html_data = '<table cellpadding="8" cellspacing="0"><tr><td width="33%"> ' + this.From_Date + ': ' + 
      this.from_date + '</td><td width="33%"> ' + this.To_Date + ': ' + this.to_date + '</td><td width="33%"> ' + 
      this.Level + ': ' + this.Level + " " + this.model['level_id'] + '</td></tr></table>';

    let table = (document.getElementById('trail_table2') as HTMLTableElement);
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
